import Sidebar from "../components/Sidebar";
import ChatWindow from "../components/ChatWindow/ChatWindow";
import styles from "./chatpage.module.css";
import Header from "../components/Header";
import { useMsal } from "@azure/msal-react";
import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import PageLoader from "../components/PageLoader";

export default function ChatBrandPage() {
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const [sidebarOpen, setSidebarOpen] = useState(isTablet ? false : true);

  // store - agent is already fetched by RequireAgentAccess wrapper
  const currentAgent = useSelector(
    (state: RootState) => state.agents.currentAgent
  );
  const agentsLoading = useSelector(
    (state: RootState) => state.agents.currentAgentLoading
  );
  const { currentChat } = useSelector((state: RootState) => state.user);
  const user = useSelector((state: RootState) => state.auth.user);

  // Get agentId from currentAgent (as string for compatibility)
  const agentId = currentAgent?.id.toString();

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userEmail = activeAccount?.username || "Unknown User";

  const chatWindowColor = "#fff"; // White background

  const handleLogout = async () => {
    try {
      await instance.logoutPopup({
        postLogoutRedirectUri: "/",
      });
      window.location.href = "/";
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  // Show loader while agents are being fetched
  if (agentsLoading) {
    return <PageLoader label="Loading session..." activeNav="home" />;
  }

  // Check if there are any messages to change background color
  const hasMessages = currentChat && currentChat.length > 0;

  // Check if current agent is Procurement Insights to show dashboard button
  const showDashboardButton = currentAgent?.agent_name?.toLowerCase().includes("procurement") || false;

  return (
    <>
      <div
        className={styles.chatpageContainer}
        style={{
          backgroundColor: hasMessages ? "#ffffff" : "#f5f5f0",
        }}
      >
        <Sidebar
          activeNav="home"
          user={user || undefined}
          onLogout={handleLogout}
        />
        <div className={styles.mainContent}>
          <Header
            isSidebarOpen={() => setSidebarOpen(!sidebarOpen)}
            currentAgent={currentAgent}
            showDashboardButton={showDashboardButton}
          />
          <ChatWindow
            currentAgent={currentAgent}
            agentId={agentId}
            chatWindowColor={chatWindowColor}
          />
        </div>
      </div>
    </>
  );
}
